import Fingerprint2 from "fingerprintjs2";
import { isAndroid, isIOS, isTablet, mobileModel, mobileVendor } from "react-device-detect";

export const ANDROID_DEVICE = "Android";

export const IPHONE_DEVICE = "iPhone";

export const IOS_DEVICE = "iOS";

export const getDevicePlatform = () => window.deviceInfo.getPlatform();

export const getDeviceId = () => window.deviceInfo.getId();

export const getDeviceManufacturer = () => window.deviceInfo.getManufacturer();

export const getDeviceModel = () => window.deviceInfo.getModel();

// export const getDisplay = () => (window.innerWidth >= 860 ? "desktop" : "mobile");

const MIMETypes = {
    txt: "text/plain",
    csv: "text/csv",
    pdf: "application/pdf",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const getDisplay = () => {
    if (window.innerWidth >= 860) {
        if (window.innerWidth <= 1370) {
            return "smallDesktop";
        }
        return "desktop";
    }
    if (window.innerWidth >= 450) {
        return "tablet";
    }
    return "mobile";
};

export const isMobileNative = !!window.cordova;

export const getMobileOS = (display) => {
    if (isMobileNative) {
        return getDevicePlatform();
    }
    if (display === "mobile") {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return ANDROID_DEVICE;
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return IOS_DEVICE;
        }
    }

    return "unknown";
};

const deviceOptions = {
    NOT_AVAILABLE: "false",
    ERROR: "error",
    EXCLUDED: "excluded",
    excludes: {
        language: true,
        timezone: true,
        timezoneOffset: true,
        userAgent: true,
        sessionStorage: true,
        localStorage: true,
        indexedDb: true,
        addBehavior: true,
        openDatabase: true,
        doNotTrack: true,
        plugins: true,
        canvas: true,
        webgl: true,
        adBlock: true,
        enumerateDevices: true,
        availableScreenResolution: true,
        deviceMemory: true,
        fonts: true,
        audio: true,
        pixelRatio: true,
        hardwareConcurrency: true,
    },
    fonts: { extendedJsFonts: true },
};

export const getExtraInfo = async () => {
    const components = await Fingerprint2.getPromise(deviceOptions);
    const obj = components.reduce((acc, curr) => {
        acc[curr.key] = curr.value;
        return acc;
    }, {});
    if (mobileVendor !== "none") {
        obj.model = `${mobileVendor} - ${mobileModel}`;
    }
    obj.isTablet = isTablet;
    obj.isAndroid = isAndroid;
    obj.isIOS = isIOS;
    return obj;
};

export const getDeviceFingerprint = async () => {
    const components = await Fingerprint2.getPromise(deviceOptions);

    const values = components.map((component) => component.value);
    return Fingerprint2.x64hash128(values.join(""), 31);
};

export const getFolderPath = () => {
    // iOS, Android, BlackBerry 10, windows
    let exportDirectory = window.cordova.file.DataDirectory;

    if (window.cordova.file.documentsDirectory !== null) {
        // iOS, OSX
        exportDirectory = window.cordova.file.documentsDirectory;
    } else if (window.cordova.file.externalRootDirectory !== null) {
        // Android, BB10
        exportDirectory = `${window.cordova.file.externalRootDirectory}/Download/`;
    }

    return exportDirectory;
};

export const getScreenHeight = () => window.screen.height;

export const getMIMEtype = (extn) => {
    const ext = extn.toLowerCase();
    return MIMETypes[ext] || "application/octet-stream";
};
